import React from 'react';
import { TimeHistoryDTO } from '../../models/TimeHistory/TimeHistoryDTO';
import InputComponent from '../InputComponent';

export const RenderCountersInputs = (
  counterOptions: string[],
  timeHistory: TimeHistoryDTO,
  setTimeHistory: React.Dispatch<React.SetStateAction<TimeHistoryDTO>>,
  isComplete?: boolean
) => {
  return counterOptions.map((option, index) => {
    const [label, unidade] = option.split(';');
    const unitKey = `unit${index + 1}` as keyof TimeHistoryDTO;
    const counterKey = `counter${index + 1}` as keyof TimeHistoryDTO;

    return (
      <React.Fragment key={index}>
        <InputComponent
          xl={3}
          lg={3}
          md={3}
          sm={10}
          xs={10}
          style={{ width: "100%" }}
          type={"number"}
          value={timeHistory[counterKey] !== undefined ? timeHistory[counterKey] : 0}
          label={label}
          readOnly={isComplete}
          onChange={(t) => {
            if (!isComplete) {
              setTimeHistory({ ...timeHistory, [counterKey]: t, [unitKey]: unidade });
            }
          }}
        />
        <InputComponent
          xl={1}
          lg={1}
          md={1}
          sm={2}
          xs={2}
          style={{ width: "100%" }}
          type={"text"}
          value={timeHistory[unitKey] !== undefined && timeHistory[unitKey] !== null ? timeHistory[unitKey]!.toString() : unidade}
          label={"Unidade"}
          readOnly={true}
        />
      </React.Fragment>
    );
  });
};